<div id="web-app" class="identity-verification" role="dialog" aria-label="Identity verification">
  <div class="identity-verification__header">
    <span class="identity-verification__title">Identity verification</span>
    <button type="button" class="identity-verification__dismiss" (click)="onDismiss()">Close</button>
  </div>

  <!--
    The vendor SDK mounts its own cross-origin frames into this element. It lives
    in host DOM, never in the widget frame: the access token and the document
    capture must not be reachable from a widget bundle.
  -->
  <div [id]="containerId" class="identity-verification__container"></div>

  <div class="identity-verification__note" *ngIf="submitted">
    Your documents have been submitted. The result usually arrives within a few minutes.
  </div>
  <div class="identity-verification__error" *ngIf="error">{{ error }}</div>
</div>
